'use strict';

module.exports = {
	id: darc.types.primary(String),
	count: Number,
	firstDateAwarded: Date,
	latestDateAwarded: Date
};
